import React from "react"
import { useLocation } from "react-router-dom"
import GamesProvider from "contexts/GamesContext"
import SpeechSettingsProvider from "contexts/SpeechSettingsContext"
import TranslatorProvider from "contexts/TranslatorContext"
import { routes, prefixRoutes } from "common/navigationRoutes"
import { useGameTracker } from "../pages/games/hooks/useGameTracker"

const GamesTracker = () => {
  useGameTracker()
  return null
}

export const GamesRouteProviders = ({ children }) => {
  const location = useLocation()
  const prefix = process.env.PUBLIC_URL || ""
  const basePath = location.pathname
    ?.toLowerCase()
    .startsWith(prefix.toLowerCase())
    ? location.pathname?.substring(prefix.length)
    : location.pathname

  let cleanPath = basePath?.toLowerCase() || ""
  const matchingPrefix = Object.values(prefixRoutes).find((prefix) =>
    cleanPath.startsWith(prefix)
  )
  if (matchingPrefix) {
    cleanPath = cleanPath.substring(matchingPrefix.length)
  }

  const isGamesRoute = cleanPath.startsWith(routes.NEW_GAMES)

  if (isGamesRoute) {
    return (
      <TranslatorProvider>
        <GamesProvider>
          <GamesTracker />
          <SpeechSettingsProvider>{children}</SpeechSettingsProvider>
        </GamesProvider>
      </TranslatorProvider>
    )
  }
  return <>{children}</>
}
